import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=1ae64d9f&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=1ae64d9f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae64d9f",
  null
  
)

export default component.exports